import { isTrackingParam } from "config/trackingParams";

/**
 * Adds noindex/nofollow to the search page meta when the URL carries params
 * that produce a non-canonical permutation (filters, pagination, sort, etc.).
 *
 * Pure marketing/tracking params (utm_*, gclid, fbclid, ...) are ignored so
 * paid-campaign landing URLs stay indexable — only params that actually change
 * page state force noindex.
 *
 * @param {Object} baseMeta - Meta derived from the search API response.
 * @param {string} locationSearch - location.search (e.g. "?sort=price&page=2").
 * @returns {Object} baseMeta unchanged, or a copy with noindex/nofollow true.
 */
export function getSearchMeta(baseMeta, locationSearch) {
	if (!locationSearch) {
		return baseMeta;
	}

	const params = new URLSearchParams(locationSearch);
	const hasStateParam = [...params.keys()].some(
		(key) => !isTrackingParam(key)
	);

	return hasStateParam
		? { ...baseMeta, noindex: true, nofollow: true }
		: baseMeta;
}
